import { Calendar, RefreshCw } from "lucide-react";
import { FC } from "react";

interface HeaderComponentProps {
  handleReset: () => void;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
}

export const HeaderComponent: FC<HeaderComponentProps> = ({
  handleReset,
  selectedDate,
  setSelectedDate,
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-semibold">Quick Add Staff/Inventory</h1>
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <Calendar size={16} className="text-gray-400" />
          <input
            type="date"
            className="border rounded-lg p-2"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>
        <button
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
          onClick={handleReset}
        >
          <RefreshCw size={16} />
          <span>Reset</span>
        </button>
      </div>
    </div>
  );
};
